import { useQuery } from "@tanstack/react-query";
import ky from "ky";

const queryKeyBase = "ddc-account-search-user-permissions";

const url = `/landing/nxlambda/accountSearch/getUserPermissions`;

const staleTime = 600000; // 10 mins

export function useGetUserPermissions(enabled = true) {
  return useQuery({
    queryKey: [queryKeyBase],
    queryFn: () => fetchUserPermissions(),
    staleTime,
    retry: false,
    enabled
  });
}

const fetchUserPermissions = async (): Promise<string[]> => {
  return ky.get(url).json<string[]>();
};
